import {FC, useState} from 'react'
import {OverlayTrigger, Tooltip} from 'react-bootstrap'
import style from './tooltip.module.css'
import {i18n} from '../../translate/i18n'

type Props = {
  text: string
  icon?: any
  link?: string
  children?: React.ReactNode
  products?: any
}

const handleClick = async (productId: string) => {
  window.open(`/product_food/editar/${productId}`, '_blank', 'noreferrer')
}

const renderTooltip = (props: any) => (
  <Tooltip id='button-tooltip' className={style.mytooltip}>
    {props.products ? (
      <table>
        <thead>
          <tr>
            <th>{props.text}</th>
          </tr>
        </thead>
        <tbody>
          {props.products.length > 0 ? (
            props.products.map((item: any) => (
              <tr
                key={item.id}
                onClick={() => handleClick(item.product.id)}
                style={{cursor: 'pointer'}}
              >
                <td>
                  {item.product.code} - {item.product.name}
                </td>
              </tr>
            ))
          ) : (
            <tr>
              <td>{i18n.t(`optional.emptyProduct`)}</td>
            </tr>
          )}
        </tbody>
      </table>
    ) : (
      <>
        {props.text}
        {props.link && (
          <a href={props.link} target='_blank' rel='noreferrer'>
            {props.link}
          </a>
        )}
      </>
    )}
  </Tooltip>
)

const MyTooltip: FC<Props> = (Props) => {
  const [showTooltip, setShowTooltip] = useState(false)

  const handleMouseEnter = () => {
    setShowTooltip(true)
  }

  const handleMouseLeave = () => {
    setShowTooltip(false)
  }

  const {text, icon, link, children, products} = Props
  return (
    <div
      className='d-flex align-items-end mx-2'
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
    >
      <OverlayTrigger
        placement='right'
        overlay={renderTooltip({text, link, products})}
        trigger={['hover', 'focus']}
        delay={{show: 0, hide: 0}}
        show={showTooltip}
      >
        {icon ? (
          <i className={`bi bi-${icon} fs-4 text-black`}></i>
        ) : children ? (
          <span>{children}</span>
        ) : (
          <span>Hover me to see</span>
        )}
      </OverlayTrigger>
    </div>
  )
}

export {MyTooltip}
